export const partsData = {
  '100625C': "Cellular Modem",
  'R100625C': "Rental Cellular Modem",
  'R100723W': "WIFI Modem",
  'R100226C': "Rental Cellular Modem - A Series",
  '1090297': "Amara Gel Headgear",
  '1090698-G': "Amara Gel Clips",
  '1090296': "Amara Gel Headgear - Reduced Size",
  '1090490': "Amara Gel Cushion P",
  '1090492': "Amara Gel Cushion S",
  '1090493': "Amara Gel Cushion M",
  '1090494': "Amara Gel Cushion L",
  '1090696': "Amara View Headgear - Large",
  '1090697': "Amara View Headgear - Standard",
  '1136626': "Amara View Clips - Magnetic",
  '1090698-V': "Amara View Clips",
  '1090692': "Amara View Cushion S",
  '1090693': "Amara View Cushion M",
  '1090694': "Amara View Cushion L",
  '1090689': "Amara View Quick Release Tube",
  '1133450': "DreamWear Full Face Headgear",
  '1133454': "DreamWear Full Face Clips - Magnetic",
  '1133430': "DreamWear Full Face Cushion S",
  '1133431': "DreamWear Full Face Cushion M",
  '1133433': "DreamWear Full Face Cushion MW",
  '1133432': "DreamWear Full Face Cushion L",
  '1116748': "DreamWear EE Elbow",
  '1116745': "DreamWear Frame S",
  '1116746': "DreamWear Frame M",
  '1116747': "DreamWear Frame L",
  '1116751': "DreamWear Headgear with arms",
  '1116754': "DreamWear Fabric Wraps",
  '1116750': "DreamWear Nasal Headgear",
  '1146472': "DreamWear Silicone Pillow S",
  '1146473': "DreamWear Silicone Pillow M",
  '1146475': "DreamWear Silicone Pillow MW",
  '1146474': "DreamWear Silicone Pillow L",
  '1137964': "DreamWisp Headgear",
  '1137965': "DreamWisp Headgear - Large",
  '1120434': "DreamWisp Clips - Magnetic",
  '1137966': "DreamWisp Headgear - Reduced Size",
  '1060807': "FitLife Headgear S",
  '1060808': "FitLife Headgear L",
  '1089990': "FitLife Headgear XL",
  '1060809': "FitLife Elbow",
  '7041': "Mask Swivel",
  '1060913': "FitLife Headgear Clips",
  '1105176': "Nuance Headgear",
  '1105178': "Nuance Pro Headgear",
  '1094086': "Wisp Cushion P",
  '1094087': "Wisp Cushion S/M",
  '1094088': "Wish Cushion L",
  '1112031': "Wisp Cushion XL",
  '1094082': "Wisp Headgear Standard",
  '1094078': "Wisp Headgear L",
  '1109307': "Wisp Headgear Reduced Size",
  '1120434-W': "Wisp Magnetic Headgear Clips",
  '1094083': "Wisp Headgear Clips",
  '1144267': "Dreamstation 80w Power Supply",
  '1039026': "Dreamstation Power Cord UK Plug",
  '1006085': "Deluxe Chin Strap",
  '1012911': "Premium Chin Strap",
  '302418': "Pressure Valve",
  '312710': "O2 Enrichment Attachment",
  '1121162': "Dreamstation Carry Case",
  '1124465': "Dreamstation Travel Case",
  '1126942': "Lithium ION Battery PAP",
  'R1124009': "Rental Lithium ION Battery PAP",
  '1126944': "Lithium ION Battery Respiratory",
  '1142834': "Dreamstation Carry Case",
  '1142982': "A Series Power Supply",
  '300DBM': "A40 Pro Detachable Battery Module"
};

export const partsDataPL = {
  '100625C': "Rura Standardowa Dream Station 15mm",
  'R100625C': "Rura Podgrzewana Dream Station 15mm",
  'R100723W ': "Rura Mikro elastyczna DreamStation 12mm ",
  'R100226C': "Rura podgrzewana Mikro elastyczna DreamStation 12mm ",
  '1090297': "Rura do maski Amara View",
  '1090698-G': "Poduszka Amara GEL P",
  '1090296': "Poduszka Amara GEL S",
  '1090490': "Poduszka Amara Gel M",
  '1090492': "Poduszka Amara Gel L",
  '1090493': "Poduszka Amara P",
  '1090494': "Poduszka Amara S",
  '1090696': "Poduszka Amara M",
  '1090697': "Poduszka Amara L",
  '1136626': "Poduszka Amara View L",
  '1090698': "Poduszka Amara View M",
  '1090692': "Poduszka Amara View S",
  '1090693': "Poduszka Dream Wear L",
  '1090694': "Poduszka Dream Wear M",
  '1090689': "Poduszka Dream Wear S",
  '1133450': "Poduszka Dream Wear MW",
  '1133454': "Poduszka Dream Wear Full Face S",
  '1133430': "Poduszka Dream Wear Full Face M",
  '1133431': "Poduszka Dream Wear Full Face L",
  '1133433': "Poduszka Dream Wear Full Face MW",
  '1133432': "Poduszka Dream Wear Silicone Pillows S",
  '1116748': "Poduszka Dream Wear Silicone Pillows M",
  '1116745': "Poduszka Dream Wear Silicone Pillows L",
  '1116746': "Poduszka Dream Wear Silicone Pillows MW",
  '1116747': "Poduszka DreamWisp  rozmiar P",
  '1116751': "Poduszka DreamWisp  rozmiar S",
  '1116754': "Poduszka Dream Wisp L",
  '1116750': "Poduszka Dream Wisp M",
  '1146472': "Poduszka Dream Wisp XL",
  '1146473': "Poduszka do maski PICO S/M",
  '1146475': "Poduszka do maski PICO L",
  '1146474': "Poduszka do maski PICO XL",
  '1137964': "Pasy do maski Amara ",
  '1137965': "Pasy do maski Amara Gel ",
  '1120434': "Pasy do maski Amara View ",
  '1137966': "Pasy do maski DreamWear",
  '1060807': "Pasy do maski DreamWear FullFacee",
  '1060808': "Pasy do maski DreamWear Silicone Pillows",
  '1089990': "Pasy do maski PICO",
  '1060809': "Zasilacz DreamStation",
  '7041': "Modem DreamStation"
};